import React, { useState, useEffect } from "react";
import axios from "axios";
import { format } from "date-fns";
import { hi } from "date-fns/locale";
import { Link } from "react-router-dom";
import { Circles } from 'react-loader-spinner';


const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
    //return text.substring(0, maxLength) + '...';
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};


function TajaKhabar5() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.shabdtoday.com/api/home/sehat"
        );
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // Define your base URL for news images

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }


  if (error) {
    return <div>Error: {error}</div>;
  }
  const baseUrl = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";
  return (
    <div>
      <div className="ak-block-header ak-block-header-style-5 no-tabs">
        <div
          className="main-wdgt container"
          id="widget-rs-4937"
          data-vars-widget-type="home"
          data-vars-widget-name="astrology"
          data-vars-orderid={10}
        >
          <div>
            <span className='head' style={{ color: 'crimson', marginLeft: 25 }}>
              {/* टॉप हेडलाइंस */}
              
            </span>
          </div>
          {/* <div className="wdgt-hdng">
            <h1 className="head">
              <Link to="#" title="टॉप हेडलाइंस " aria-label="टॉप हेडलाइंस">
                टॉप हेडलाइंस
              </Link>
            </h1>
          </div> */}
        </div>
      </div>
      <div id="carouselExample" className="carousel slide " data-bs-ride="carousel">
        <div className="carousel-inner">
          {posts.sehat.slice(0, 5).map((newsItem) => (
            <div key={newsItem.mainKhabarId} className="carousel-item active" data-bs-interval="2000">
              <img to={`/TajaKhabarDetailsNews/${newsItem.mainKhabarId}`} src={image_resize + "?url=" + baseUrl + newsItem.newsImage + "&w=333&h=188&outtype=webp"} className="d-block w-100" alt="..." />
              <div className="carousel-caption d-none d-md-block">
                <Link to={`/News-Details/${newsItem.mainKhabarId}`} area-lable={stripHtmlTags(newsItem.newsHeading, 30)}>
                  <h1> {stripHtmlTags(newsItem.newsHeading, 30)}</h1>
                </Link>

              </div>
            </div>
          ))}

        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>

    </div>
  )
}

export default TajaKhabar5
